// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__bP4a4","title":"styles_title__1knNC","rateWrap":"styles_rateWrap__2NyjH"};